import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useCategoriesByCompanySelect from 'modules/categories/hooks/use-categories-by-company-select';
import useCompaniesSelectData from 'modules/companies/hooks/use-companies-select-data';
import useCreateProduct from 'modules/products/hooks/use-create-product';
import {
  PriceModeEnum,
  ProductProps,
  translatedProductProps,
} from 'modules/products/types';
import React, {useState} from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateProduct: React.FC = () => {
  const {
    getInput,
    getSwitch,
    getTextArea,
    getSelect,
    getImagePicker,
    getPriceInput,
  } = useFormInputs<ProductProps>();
  const accessControls = useAccessControls();
  const [companyId, setCompanyId] = useState<string | undefined>(
    accessControls.companyId ?? undefined,
  );
  const categoriesSelect = useCategoriesByCompanySelect(companyId);
  const companiesSelect = useCompaniesSelectData();

  const handleSubmit = (data: ProductProps) => {
    const formData = new FormData();

    formData.append('name', data.name);
    formData.append('description', data.description ?? '');
    formData.append('companyId', data.companyId ?? accessControls.companyId);
    formData.append('priceMode', data.priceMode);
    if (data.price) formData.append('price', String(data.price));
    formData.append('active', String(data.active));
    formData.append('categoryId', data.categoryId);
    if (data.subCategoryId)
      formData.append('subCategoryId', data.subCategoryId);
    if (data.image && (data.image as any) instanceof File)
      formData.append('image', data.image);

    return formData;
  };

  return (
    <Creation<ProductProps>
      titleBar={{title: 'Cadastrar produto'}}
      onSubmit={useCreateProduct}
      defaultValues={{active: true}}
      onFormStateChange={(data) => {
        if (data.companyId && data.companyId !== companyId)
          setCompanyId(data.companyId);
      }}
      {...{handleSubmit}}
      inputs={[
        getInput({
          name: 'name',
        }),
        getTextArea({name: 'description'}),
        getSelect({
          name: 'companyId',
          data: companiesSelect.data,
          isLoading: companiesSelect.isLoading,
          hidden: () => !!accessControls.companyId,
        }),
        getSelect({
          name: 'priceMode',
          data: [
            {label: 'Fixo', value: PriceModeEnum.fixed},
            {label: 'Tamanho', value: PriceModeEnum.size},
            {label: 'Adicionais', value: PriceModeEnum.additionals},
          ],
        }),
        getPriceInput({
          name: 'price',
          hidden: (data) => data.priceMode !== PriceModeEnum.fixed,
        }),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'categoryId',
          data: categoriesSelect.data,
          isLoading: categoriesSelect.isLoading,
        }),
        getImagePicker({label: 'Imagem', name: 'image'}),
      ]}
      translationKey={translatedProductProps}
    />
  );
};

export default CreateProduct;
